import { render, staticRenderFns } from "./LangTabs.vue?vue&type=template&id=3c2367c7&"
import script from "./LangTabs.vue?vue&type=script&lang=js&"
export * from "./LangTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LangTabs.vue"
export default component.exports